// GENERATED FILE, PLEASE DO NOT EDIT
var TableRowBodySmall = 40;
var TableRowBodyMedium = 40;
var TableRowBodyLarge = 40;
var TableRowHeaderSmall = 40;
var TableRowHeaderMedium = 40;
var TableRowHeaderLarge = 40;
var SizeSemanticsAll = {
  TableRowBodyLarge: TableRowBodyLarge,
  TableRowBodyMedium: TableRowBodyMedium,
  TableRowBodySmall: TableRowBodySmall,
  TableRowHeaderLarge: TableRowHeaderLarge,
  TableRowHeaderMedium: TableRowHeaderMedium,
  TableRowHeaderSmall: TableRowHeaderSmall
};

export { SizeSemanticsAll, TableRowBodyLarge, TableRowBodyMedium, TableRowBodySmall, TableRowHeaderLarge, TableRowHeaderMedium, TableRowHeaderSmall, SizeSemanticsAll as default };
